/**
 * Verified Reports upsell gating (RAC-10337).
 *
 * Clicking "View Application" first offers the landlord the Verified Reports
 * (enhanced screening) upsell. Who sees it, and how often:
 *
 *   - non-Pro landlords (free / RiskGuard): every click, for every applicant
 *   - RiskGuard Pro landlords: once per applicant, tracked server-side in
 *     `applications.eso_upsell_seen_at` and, within the same page render, in
 *     the `seenApplicationIds` set
 *
 * Never shown to shared-view collaborators (they cannot buy reports) or when the
 * applicant already has every add-on assigned (nothing left to sell).
 *
 * Pure + framework-free on purpose so it is unit-testable in isolation.
 */

const PRO_SUBSCRIPTION_TYPE = 'rentrisk-protect-pro';

/**
 * @param {object} params
 * @param {{id: number, required_addons?: Array, eso_upsell_seen_at?: ?string}} params.application
 * @param {Array} params.addons              All purchasable enhanced-screening add-ons.
 * @param {?string} params.subscriptionType  The landlord's plan slug.
 * @param {boolean} params.isSharedViewOnly  True for shared-view collaborators.
 * @param {Set<number>} [params.seenApplicationIds]
 * @returns {boolean}
 */
export function shouldShowVerifiedReportsUpsell({
    application,
    addons = [],
    subscriptionType = null,
    isSharedViewOnly = false,
    seenApplicationIds = new Set(),
}) {
    if (!application || isSharedViewOnly) {
        return false;
    }

    if (!addons.length || (application.required_addons?.length ?? 0) >= addons.length) {
        return false;
    }

    if (subscriptionType !== PRO_SUBSCRIPTION_TYPE) {
        return true;
    }

    return !application.eso_upsell_seen_at && !seenApplicationIds.has(application.id);
}
